/*
* Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/

import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import { Observable } from 'rxjs';
import {EquipmentConnection} from '../models/equipment-connection.model';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class EquipmentService {
    api_url: any;

    constructor(private apiService: ApiService) {
        this.api_url = environment.cdt.api_url;
    }

    getRelatedEquipmentConnections(equipmentIri: string, isUpstream: boolean) {
        return isUpstream ? this.upstream(equipmentIri) : this.downstream(equipmentIri);
    }

    upstream(equipmentIri: string): Observable<[EquipmentConnection]> {
        let params = new HttpParams();
        params = params.set('equipmentIri', equipmentIri);
        return this.apiService.get('/equipments/upstream', this.api_url, params);
    }

    downstream(equipmentIri: string): Observable<[EquipmentConnection]> {
        let params = new HttpParams();
        params = params.set('equipmentIri', equipmentIri);
        return this.apiService.get('/equipments/downstream', this.api_url, params);
    }

}
